module.exports = __webpack_public_path__ + "img/delete.1f50fe83.svg";